import { reactRoute } from '../../../utils/routing/reactRoute'
import type { InvoiceBillingStage } from '../enums/invoiceBillingStage'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { getInvoiceDraftEditRoute } from './getInvoiceDraftEditRoute'

interface GetInvoiceOrDraftRouteParams {
  billingStage?: InvoiceBillingStage
  documentId: string
  documentType: InvoiceDocumentType
}

export const getInvoiceOrDraftRoute = ({
  billingStage,
  documentId,
  documentType,
}: GetInvoiceOrDraftRouteParams): string =>
  documentType === InvoiceDocumentType.InvoiceDraft
    ? getInvoiceDraftEditRoute(billingStage, documentId, documentType)
    : reactRoute.organization.invoices.getViewInvoiceRoute(documentId, documentType)
